import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import type { ChannelAccountAuthorizationData, ReplySubmitDto } from '@/interfaces/service/appstore/appstore.interface';

interface PostReplyState {
  replyData: ReplySubmitDto | null;
  authData:
    | (ChannelAccountAuthorizationData & {
        accountId: string;
        accountPassword: string;
      })
    | null;
  userPhoneNumber: string;
  setReplyData: (data: ReplySubmitDto) => void;
  setAuthData: (
    data: ChannelAccountAuthorizationData & {
      accountId: string;
      accountPassword: string;
    }
  ) => void;
  setUserPhoneNumber: (phoneNumber: string) => void;
}

export const PostReplyStore = create(
  persist<PostReplyState>(
    (set) => ({
      replyData: null,
      authData: null,
      userPhoneNumber: '',
      setReplyData: (data) => set((state) => ({ ...state, replyData: data })),
      setAuthData: (data) => set((state) => ({ ...state, authData: data })),
      setUserPhoneNumber: (phoneNumber) => set((state) => ({ ...state, userPhoneNumber: phoneNumber }))
    }),
    { name: 'replyData', storage: createJSONStorage(() => sessionStorage) }
  )
);
